// extracted by mini-css-extract-plugin
export default {"entityTitle":"m4Xjne","artistTitle":"HaWgZj"};